module.exports = "https://www.gc-qa.gnp.com.mx/834a2aa571f98710f7a7d11fb76efa02.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/vpn_key_24px.svg
// module id = 8177
// module chunks = 0